import React, { useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  Typography,
  Paper,
} from '@material-ui/core';
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import { Comisionist } from 'types/api/responses';

type Props = {
  comisionist: Comisionist;
};

export function DocumentsComisionist({ comisionist }: Props) {
  const [documents, setDocuments] = useState<any[]>([]);


  const requiredDocs = comisionist.type === 'Formal'
    ? ['DUI/NIT', 'NRC', 'Ficha Firmada']
    : ['DUI/NIT', 'Ficha Firmada'];

  const uploadedDocs = requiredDocs.filter((doc) =>
    documents.some((d) => d.name === doc)
  );
  const missingDocs = requiredDocs.filter((doc) =>
    !documents.some((d) => d.name === doc)
  );

  const handleUploadClick = (docType: string) => {
    // TODO: Implementar lógica de carga de archivo
    console.log('Subir documento:', docType);
  };

  const handleCameraClick = (docType: string) => {
    // TODO: Implementar lógica de captura de cámara
    console.log('Abrir cámara para:', docType);
  };

  const handleDeleteDocument = (docId: number) => {
    // TODO: Implementar lógica de eliminación
    console.log('Eliminar documento:', docId);
  };

  const handleViewDocument = (docId: number) => {
    // TODO: Implementar visualización de documento
    console.log('Ver documento:', docId);
  };

  return (
    <Box>
      <Typography variant="body2" color="textSecondary" gutterBottom>
        Perfil <strong>{comisionist.type}</strong> requiere: {requiredDocs.join(', ')}.
        Los documentos faltantes se marcan con borde rojo.
      </Typography>


      <Card style={{ marginTop: '16px' }}>
        <CardHeader
          title={`Carga de Documentos — Comisionista ${comisionist.type}`}
          subheader={`${uploadedDocs.length} / ${requiredDocs.length} documentos cargados`}
        />
        <CardContent>
          <Grid container spacing={2}>
            {requiredDocs.map((docType) => {
              const isUploaded = uploadedDocs.includes(docType);
              const isMissing = missingDocs.includes(docType);

              return (
                <Grid item xs={12} sm={6} md={4} key={docType}>
                  <Paper
                    style={{
                      padding: '16px',
                      textAlign: 'center',
                      border: isMissing ? '2px dashed #c62828' : '2px solid #2e7d32',
                      backgroundColor: isMissing ? '#fff5f5' : '#f1f8e9',
                      minHeight: '150px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Box>
                      <Typography variant="h6" style={{ fontSize: '28px' }}>
                        {docType === 'DUI/NIT' && '🆔'}
                        {docType === 'NRC' && '🏛'}
                        {docType === 'Ficha Firmada' && '📝'}
                      </Typography>
                      <Typography variant="subtitle2" style={{ fontWeight: 700 }}>
                        {docType}
                      </Typography>
                      {isMissing && (
                        <Typography
                          variant="caption"
                          style={{ color: '#c62828' }}
                        >
                          ⚠️ Documento requerido
                        </Typography>
                      )}
                      {isUploaded && (
                        <Typography variant="caption" style={{ color: '#2e7d32' }}>
                          {docType}_cargado.pdf
                        </Typography>
                      )}
                    </Box>

                    {isUploaded && (
                      <Box display="flex" justifyContent="center" flexWrap="wrap" style={{ gap: '8px' }}>
                        <Button
                          size="small"
                          startIcon={<DownloadIcon />}
                          onClick={() => handleViewDocument(1)}
                        >
                          Ver
                        </Button>
                        <Button
                          size="small"
                          startIcon={<DeleteIcon />}
                          onClick={() => handleDeleteDocument(1)}
                          
                        >
                          Eliminar
                        </Button>
                      </Box>
                    )}

                    {isMissing && (
                      <Box display="flex" justifyContent="center" flexWrap="wrap" style={{ gap: '8px' }}>
                        <Button
                          size="small"
                          variant="contained"
                          color="primary"
                          startIcon={<CloudUploadIcon />}
                          onClick={() => handleUploadClick(docType)}
                          
                        >
                          Subir
                        </Button>
                        <Button
                          size="small"
                          variant="outlined"
                          startIcon={<PhotoCameraIcon />}
                          onClick={() => handleCameraClick(docType)}
                          
                        >
                          Escanear
                        </Button>
                      </Box>
                    )}
                  </Paper>
                </Grid>
              );
            })}
          </Grid>

          {missingDocs.length > 0 && (
            <Box
              mt={2}
              p={2}
              bgcolor="#ffebee"
              border="1px solid #ef9a9a"
              borderRadius={1}
            >
              <Typography variant="body2" style={{ color: '#c62828' }}>
                📄 Falta cargar: <strong>{missingDocs.join(', ')}</strong>. El registro
                permanecerá en estado <em>Pendiente Documentos</em> hasta completar la carga.
              </Typography>
            </Box>
          )}

          <Box mt={3} display="flex" justifyContent="flex-end" style={{ gap: '8px' }}>
            <Button variant="outlined">← Volver a Bandeja</Button>
            {missingDocs.length === 0 && (
              <Button variant="contained" color="primary">
                ✔ Marcar como Completo
              </Button>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
}
